import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User turned on "Require email" toggle on share link',
  name: 'toggled_anonymous_account_requirement_on',
  params: [
    {
      description: 'Id of an object that share link is generated for',
      name: 'object_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of an object that share link is generated for',
      name: 'object_type',
      required: true,
      type: 'enum',
      values: ['board', 'clip'],
    },
    {
      description: 'Generated share url',
      name: 'share_url',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
